import { UpdateVersionDetailMeta, UpdateVersionDetailPayload } from 'types/store/UpdateVersionDetail';
import { createAsyncReducer } from 'utils/Redux';

import { updateVersionDetailActions } from '../actions';

export default createAsyncReducer<UpdateVersionDetailMeta, UpdateVersionDetailPayload>(updateVersionDetailActions);
